import { __rest } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import React from 'react';
import styled from '@emotion/styled';
import { i as img } from './default_image-f8521c37.js';
import { getStyle } from './utils.es.js';
import './InputNumber-7d93e963.js';
import { Link } from './components/shared/Link.es.js';
import 'rc-select';
import '@teko-builder/icons';
import './FormItem-098fa619.js';
import './DateTimePickerMobile-749dc497.js';
import './RadioGroup-4b4abf08.js';
import './Col-475038db.js';
import './Slider-93041044.js';
import './Container-ca9f82d8.js';
import './Divider-600cb92e.js';
import './Ripple-abf0f8a0.js';
import './Image-efa43cf5.js';
import './ModalHeader-a3d30e4f.js';
import './Spin-a6892495.js';
import '@teko-builder/types/pb';
import { g as getImageUrlFromGoogleUserContent } from './image-1466e3c0.js';

const ImageWrapper = styled.div(({ alignment }) => `
  text-align: ${alignment};
`);
const StyledImage = styled.img(({ commonStyle }) => `
  max-width: 100%;
  display: inline-block;
  transition: transform 0.3s;
  ${getStyle(commonStyle)}
`);
const Image = React.forwardRef((props) => {
    const { src, alt = '', link, width, commonStyle, alignment = 'center', ref, event, googleImageParams, isEditingMode = false } = props, rest = __rest(props, ["src", "alt", "link", "width", "commonStyle", "alignment", "ref", "event", "googleImageParams", "isEditingMode"]);
    const newSrc = getImageUrlFromGoogleUserContent(src, Object.assign({ format: 'webp', width: width }, googleImageParams));
    const pngSrc = getImageUrlFromGoogleUserContent(src, Object.assign({ format: 'png', width: width }, googleImageParams));
    const imgError = (image) => {
        image.target.src = img;
        return;
    };
    const imgEle = (jsx(StyledImage, { ref: ref, commonStyle: commonStyle, src: newSrc, loading: "lazy", alt: alt, onError: imgError, decoding: "async", className: "lazyload" }));
    const image = pngSrc ? (jsxs("picture", { children: [jsx("source", { srcSet: newSrc, type: 'image/webp' }), jsx("source", { srcSet: pngSrc, type: 'image/png' }), imgEle] })) : (imgEle);
    return (jsx(Link, Object.assign({}, link, event, { children: isEditingMode ? (image) : (jsx(ImageWrapper, Object.assign({ alignment: alignment }, rest, { children: image }))) })));
});
Image.displayName = 'Image';

export { Image as I, ImageWrapper as a };
